module.exports = __webpack_public_path__ + "chefy-scripts.png?f04b09c2278604578f9c6b8e35e82bca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chefy-scripts.png
// module id = 37
// module chunks = 0